module.exports = __webpack_public_path__ + "static/media/feelboard-section-3.da5cb619.png";